<div
  class="menu-mobile position-absolute w-100 bg-white"
  #collapse="ngbCollapse"
  [(ngbCollapse)]="isMenuCollapsed"
  [animation]="true"
>
  <ul class="list-unstyled mb-0 d-flex flex-column w-100">
    @if (!isSpanish) {
      @for (item of list; track $index) {
        <li class="menu-mobile__item">
          <div class="menu-mobile__list" *ngIf="item.list">
            <div
              class="item cursor-pointer d-flex gap-2 align-items-center"
              [ngClass]="{ 'item--active': !item.isMenuCollapsed }"
              (click)="toggleMenuCollapses(item.id!)"
              [class.active-button]="isDropdownActive(item.list)"
            >
              <a class="fw-bold"
                ><span>{{ item.name }}</span>
              </a>

              <button
                type="button"
                [attr.aria-expanded]="!item.isMenuCollapsed"
                [attr.aria-controls]="item.name + '-mobile-menu'"
                class="d-flex p-0"
              >
                <svg
                  width="16"
                  height="13"
                  viewBox="0 0 16 13"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M8 12.5L1.0718 3.5L14.9282 3.5L8 12.5Z"
                    fill="#1D1D1D"
                  />
                </svg>
              </button>
            </div>

            <div
              #collapse="ngbCollapse"
              [(ngbCollapse)]="item.isMenuCollapsed"
              [id]="item.name + '-mobile-menu'"
              class="main-collapse-list"
            >
              <ul class="list-unstyled collapse-list">
                <li *ngFor="let collapseItem of item.list">
                  <a
                    class="d-block fw-bold"
                    [routerLink]="collapseItem.path"
                    routerLinkActive="active"
                    [routerLinkActiveOptions]="{ exact: true }"
                    (click)="collapseTheMenu(true)"
                  >
                    <span class="d-block">{{ collapseItem.name }}</span>
                  </a>
                </li>
              </ul>
            </div>
          </div>

          <a
            class="item d-block fw-bold"
            [routerLink]="item.path"
            routerLinkActive="button-active"
            (click)="collapseTheMenu(true)"
            *ngIf="!item.dropdown"
            >{{ item.name }}</a
          >
        </li>
      }
      <li class="menu-mobile__item header-hcp-mobile-dropdown">
        <a
          class="item header-hcp-cta text-white fw-bold"
          [class.header-hcp-cta--open]="!isHcpMenuCollapsed"
          (click)="toggleHcpMenuCollapse($event)"
        >
          <span>For Healthcare Providers</span>
          <svg
            class="rotate"
            aria-hidden="true"
            width="16"
            height="13"
            viewBox="0 0 16 13"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path d="M8 12.5L1.0718 3.5L14.9282 3.5L8 12.5Z" fill="currentColor" />
          </svg>
        </a>
        <div
          #collapse="ngbCollapse"
          [(ngbCollapse)]="isHcpMenuCollapsed"
          class="header-hcp-mobile-dropdown__menu"
        >
          <ul class="list-unstyled mb-0">
            <li *ngFor="let hcpItem of hcpLinks">
              <a
                class="d-block fw-bold"
                [class.active]="isHcpLinkActive(hcpItem.path)"
                (click)="openHcpLink(hcpItem.path, $event)"
              >
                {{ hcpItem.name }}
              </a>
            </li>
          </ul>
        </div>
      </li>
    } @else {
      @for (item of spanishList; track $index) {
        <li class="menu-mobile__item">
          <a
            class="item d-block fw-bold"
            (click)="
              collapseTheMenu(true); scrollToSection(item.fragment || '')
            "
            *ngIf="!item.dropdown"
            >{{ item.name }}</a
          >
        </li>
      }
    }
  </ul>
  <div class="menu-mobile__bottom d-flex flex-column align-items-center">
    @if (isSpanish) {
      <div class="cta">
        <a
          class="btn btn-secondary text-center text-white fw-bold my-5"
          (click)="
            collapseTheMenu(true);
            spanishLink('https://www.questhealth.com/')
          "
          >Solicite la prueba de detección</a
        >
      </div>
    }
    <ul class="languages cursor-pointer list-unstyled d-flex">
      <li
        routerLink="/"
        class="languages__item"
        (click)="collapseTheMenu(true)"
        [ngClass]="{ 'languages__item--selected': !isSpanish }"
      >
        English
      </li>
      <li
        routerLink="/es"
        class="languages__item"
        (click)="collapseTheMenu(true)"
        [ngClass]="{ 'languages__item--selected': isSpanish }"
      >
        Español
      </li>
    </ul>
  </div>
</div>
